/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSaleProducts200ResponseAllOfData } from './GetSaleProducts200ResponseAllOfData';
import {
    GetSaleProducts200ResponseAllOfDataFromJSON,
    GetSaleProducts200ResponseAllOfDataFromJSONTyped,
    GetSaleProducts200ResponseAllOfDataToJSON,
} from './GetSaleProducts200ResponseAllOfData';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface GetSaleProducts200Response
 */
export interface GetSaleProducts200Response {
    /**
     * 
     * @type {GetSaleProducts200ResponseAllOfData}
     * @memberof GetSaleProducts200Response
     */
    data: GetSaleProducts200ResponseAllOfData;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof GetSaleProducts200Response
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the GetSaleProducts200Response interface.
 */
export function instanceOfGetSaleProducts200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetSaleProducts200ResponseFromJSON(json: any): GetSaleProducts200Response {
    return GetSaleProducts200ResponseFromJSONTyped(json, false);
}

export function GetSaleProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSaleProducts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetSaleProducts200ResponseAllOfDataFromJSON(json['data']),
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function GetSaleProducts200ResponseToJSON(value?: GetSaleProducts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetSaleProducts200ResponseAllOfDataToJSON(value.data),
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

